import StringUtils from './string-utils';

export function getModalWordings(currentLanguage: string) {
    const wordings_en = {
        header: 'Welcome!',
        provinceDropdownLabel: 'Please select your province.',
        errorMessage: 'Oops! Looks like you forgot to fill this in.',
        description: 'This information will be used for your cookie management.',
        defaultSelectedProvince: 'Select',
        confirm: 'Confirm',
        ok: 'OK',
    };

    const wordings_fr = {
        header: 'Bienvenue!',
        provinceDropdownLabel: 'Veuillez sélectionner votre province.',
        errorMessage: 'Oops! On dirait que vous avez oublié de remplir ceci.',
        description: 'Ces informations seront utilisées pour votre gestion des cookies.',
        defaultSelectedProvince: 'Sélectionner',
        confirm: 'Confirmer',
        ok: 'OK'
    };
    // Use StringUtils for case-sentitve check

    if (StringUtils.contains(currentLanguage, 'en', 0)) { return wordings_en; }
    return currentLanguage.includes('fr') ? wordings_fr : wordings_en;
}
